import React from 'react';

function WebBookingsNav({ tabs, activeTab, onTabChange, counts = {} }) {
    return (
        <nav className="web-bookings-tab-nav" role="tablist" aria-label="Booking request sections">
            {tabs.map((tab) => {
                const isActive = activeTab === tab.id;
                const count = counts[tab.id];

                return (
                    <button
                        key={tab.id}
                        type="button"
                        role="tab"
                        aria-selected={isActive}
                        className={`web-bookings-tab-nav__item${isActive ? ' is-active' : ''}`}
                        onClick={() => onTabChange(tab.id)}
                    >
                        <i className={`bi ${tab.icon}`} aria-hidden="true"></i>
                        <span>{tab.label}</span>
                        {count != null && count > 0 ? (
                            <span className="web-bookings-tab-nav__count">{count}</span>
                        ) : null}
                    </button>
                );
            })}
        </nav>
    );
}

export default WebBookingsNav;
